module.exports = __webpack_public_path__ + "img/sad.a5fd2581.svg";